/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";

import { useLocation, useNavigate } from "react-router-dom";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import AlertDialog from "../../components/AlertDialog";


export default function Prescriptions({ Booking }) {

  const { api } = useContext(FirebaseContext);
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
    updateProfile,
    updateBooking,
  } = api;
  const [state, setState] = useState({
    userType: "practiceadmin",
    firstName: "",
    lastName: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });

  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const location = useLocation();
  const [details, setDetails] = useState(location.state.Booking);
   const [updatebooking, setupdatebooking] = useState(Booking);
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  useEffect(() => {
    // const arr = [];
    // console.log("auth.info.profile", auth.info.profile);
    // if (updatebooking) {
    //   setData([updatebooking.prescriptions]);
    // } else {
    //   setData([]);
    // }

    if (details) {
      setData([details.prescriptions]);
    } else {
      setData(details);
    }
    console.log("bookings: ", data);
  }, [updatebooking]);

  // useEffect(() => {
  //   if (auth.info && auth.info.profile) {
  //     setIsdepData({
  //       isIndependent: false,
  //     });
  //   }
  // }, [auth.info]);
  // console.log("this is data", data);
  const columns = [
    { header: language.first_name, accessorKey: "firstName"},
    { header: language.last_name, accessorKey: "lastName" },

    { header: "Practice Name", accessorKey: "practiceName" },
    {
      header: "Speciality type",
      accessorKey: "specialityType",

    },
    {
      header: language.email,
      accessorKey: "email",
   
    },
    { header: "password", accessorKey: "password" },
    {
      header: language.mobile,
      accessorKey: "mobile",
     
    },
    {
      header: "Private Practice",
      accessorKey: "privatePractice",

    },
    {
      header: language.account_approve,
      accessorKey: "practiceAdminActiveStatus",
   
    },
  ];
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const      onRowAdd=(newData) =>{
    new Promise((resolve, reject) => {
      setTimeout(() => {
        checkUserExists(newData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(language.user_exists);
            reject();
          } else if (res.error) {
            alert(language.email_or_mobile_issue);
            reject();
          } else {
            newData["createdByAdmin"] = true;
            newData["userType"] = "practiceadmin";
            newData["createdAt"] = new Date().toISOString();
            newData["referralId"] =
              newData.firstName.toLowerCase() +
              Math.floor(1000 + Math.random() * 9000).toString();
            setState({
              ...state,
              newData,
            });
            let role = auth.info.profile.userType;
            if (role === "practiceadmin") {
              newData["practiceadmin"] = auth.info.uid;
              newData["practiceNumber"] =
                auth.info.profile.practiceNumber;
            } else if (role === "nurse") {
              newData["nurse"] = auth.info.uid;
              newData["practiceNumber"] =
                auth.info.profile.practiceNumber;
            } else if (role === "doctor") {
              newData["doctor"] = auth.info.uid;
              newData["practiceNumber"] =
                auth.info.profile.practiceNumber;
            }

            emailSignUp(newData).then((res) => {
              resolve();
              // console.log("i am the back data", res);
              if (res.uid) {
                setTimeout(() => {
                  setCommonAlert({
                    open: true,
                    msg: language.account_create_successfully,
                  });
                  navigate("/login");
                  // console.log(newData);
                }, 3000);
              } else {
                setCommonAlert({
                  open: true,
                  msg: language.reg_error,
                });
              }
            });
          }
        });
      }, 600);
    })
  };

  const  onRowUpdate= (newData, oldData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        dispatch(editUser(oldData.id, newData));
      }, 600);
    })};

  const  onRowDelete=(oldData) =>{
    features.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            dispatch(deleteUser(oldData.id));
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(language.demo_mode);
          }, 600);
        })
      };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
